// eslint-disable-next-line import/prefer-default-export
export const DATA_THEME_CONNECTE = [
    {
        key: '1',
        value: 'Problème de connexion',
        libelle: 'Problème de connexion',
    },
    {
        key: '2',
        value: 'Problème de création de compte',
        libelle: 'Problème de création de compte',
    },
    {
        key: '3',
        value: "Demande de modification d'informations personnelles",
        libelle: "Demande de modification d'informations personnelles",
    },
    {
        key: '4',
        value: "Demande de rectification de mon quota d'armes soumises à autorisation",
        libelle: "Demande de rectification de mon quotas d'armes soumises à autorisation",
        restriction: 'Tireur sportif',
    },
    {
        key: '5',
        value: 'Autorisation papier en cours',
        libelle: 'Autorisation papier en cours',
        restriction: 'Tireur sportif',
    },
    {
        key: '6',
        value: 'Demande de régularisation d’armes (Modèle 13)',
        libelle: 'Demande de régularisation d’armes (Modèle 13)',
        restriction: 'Tireur sportif',
    },
    {
        key: '7',
        value: 'Transmission de pièces justificatives',
        libelle: 'Transmission de pièces justificatives',
        restriction: 'Tireur sportif',
    },
    {
        key: '8',
        value: 'Changement de responsable légal',
        libelle: 'Changement de responsable légal',
    },
    {
        key: '9',
        value: 'Autre',
        libelle: 'Autre',
    },
];

export const DATA_THEME_NON_CONNECTE = [
    {
        key: '1',
        value: 'Problème de connexion',
        libelle: 'Problème de connexion',
    },
    {
        key: '2',
        value: 'Problème de création de compte',
        libelle: 'Problème de création de compte',
    },
    {
        key: '3',
        value: 'Changement de responsable légal',
        libelle: 'Changement de responsable légal',
    },
    {
        key: '4',
        value: 'Autre',
        libelle: 'Autre',
    },
];

export const tailleFichiers = (fichiers) => {
    let size = 0;
    for (let i = 0; i < fichiers.length; i += 1) {
        size += fichiers[i].size;
    }
    return size;
};

export const mimeTypesAccepted = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];

export const formatFichiers = (fichiers, tab) => {
    for (let i = 0; i < fichiers.length; i += 1) {
        if (!tab.includes(fichiers[i].type)) {
            return false;
        }
    }
    return true;
};
